import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UserServiceClient } from 'fitbeat.api-clients';
import { translate } from 'react-i18next';
import { getApiConfig } from '../config';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { GoogleAnalytics } from '../services/google-analytics';
import { UserDataConsumer } from '../utils';
import { reduxForm } from 'redux-form';
import { toggleWorkoutProgramSelectModalVisible, toggleSkillLevelSelectModal, BaseModal } from '../ui';
import { View, StyleSheet, Platform, Text } from 'react-native';
import SettingsTile from './components/SettingsTile';
import SkillLevel from './components/SkillLevel';
import FitnessGoal from './FitnessGoal';
import SkillLevelScreen from './SkillLevel';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { NavigatorService } from '../utils/NavigatorService';
import ResetAppState from '../utils/ResetAppStateHelper';
import { mappedIcons, mappedTitles } from '../WorkoutGoalAssistant/utils';
import { userGoalChanged } from '../SummaryDashboard/actions';

class GoalsTab extends Component {
  userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder(), new GoogleAnalytics());

  constructor(props) {
    super(props);

    this.state = {
      isSetupScreen: false,
    };
  }

  navigateToFitnessGoal = () => {
    this.props.toggleWorkoutProgramSelectModalVisible(true);
  }

  navigateToSkillLevel = () => {
    this.props.toggleSkillLevelSelectModal(true);
  }

  userGoalChanged = () => {
    this.props.userGoalChanged();
  }

  closeWorkoutProgramDescription = () => {
    this.setSetupScreen(false);
    this.props.toggleWorkoutProgramSelectModalVisible(false);
  };

  closeSkillLevelModal = () => {
    this.setSetupScreen(false);
    this.props.toggleSkillLevelSelectModal(false);
  };

  setSetupScreen = (isSetupScreen) => {
    this.setState({ isSetupScreen });
  }

  completeGoalChange = () => {
    if (Platform.OS === 'web') {
      this.props.navigation.navigate("SummaryDashboard");
    } else {
      ResetAppState();
      NavigatorService.navigateContainerOne('AuthLoading');
    }
  }

  render() {
    const { user: { userProfile }, t, isModalVisible, skillLevelSelectModalVisible } = this.props;
    const { isSetupScreen } = this.state;
    const icon = mappedIcons[userProfile.longTermGoal]({}, Theme.BLACK);
    return (
      <>
        {!isModalVisible && !skillLevelSelectModalVisible &&
          <View style={styles.container} className='full-height'>
            <SettingsTile
              buttonMethod={this.navigateToSkillLevel}
              user={userProfile}
              sectionTitle={'Skill level'}
              buttonTitle={'Change'}
              descriptionSection={
                <View style={{ flexDirection: 'row', alignSelf: 'center', alignItems: 'center' }}>
                  <SkillLevel skillLevel={userProfile.skillLevel} t={t} />
                </View>} />
            <SettingsTile
              buttonMethod={this.navigateToFitnessGoal}
              sectionTitle={'Fitness Goal'}
              buttonTitle={'Change'}
              descriptionSection={
                <View style={{ flexDirection: 'row', alignSelf: 'center', alignItems: 'center' }}>
                  <View style={{ width: defaultScale(30), height: defaultScale(30), alignSelf: 'center' }}>{icon}</View>
                  <Text style={styles.goal}>{mappedTitles[userProfile.longTermGoal]}</Text>
                </View>} />
          </View>
        }
        <BaseModal
          title={isSetupScreen ? null : t('auth:setYourLongTermFitnessGoal')}
          subtitle={isSetupScreen ? null :
            <Text style={styles.subtitle}>{t('auth:forPersonalisedWorkoutsAndNutrition')}</Text>}
          closeIconSize={defaultScale(35)}
          closeModal={this.closeWorkoutProgramDescription}
          isModalVisible={isModalVisible}
          headerTextStyle={styles.headerTextStyle}
          containerStyle={{ height: '100vh' }}>
          <FitnessGoal
            navigation={this.props.navigation}
            isSetupScreen={isSetupScreen}
            setSetupScreen={this.setSetupScreen}
            currentSelectedGoal={mappedTitles[userProfile.longTermGoal]}
            closeWorkoutProgramDescription={this.closeWorkoutProgramDescription}
            userGoalChanged={this.userGoalChanged}
            completeGoalChange={this.completeGoalChange}
          />
        </BaseModal>
        <BaseModal
          title={t('skillLevelTitle')}
          subtitle={<Text style={styles.subtitle}>{t('skillLevelSubheader')}</Text>}
          closeIconSize={defaultScale(35)}
          closeModal={this.closeSkillLevelModal}
          headerTextStyle={styles.headerTextStyle}
          isModalVisible={skillLevelSelectModalVisible}
          containerStyle={{ height: '100vh' }}>
          <SkillLevelScreen
            navigation={this.props.navigation}
            closeSkillLevelModal={this.closeSkillLevelModal}
          />
        </BaseModal>
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.GREY_LIGHT,
    padding: defaultScale(15),
    ...Platform.select({
      web: {
        paddingHorizontal: 30,
        paddingVertical: 0,
      },
    }),
  },
  content: {
    paddingBottom: defaultScale(15),
  },
  goal: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.BLACK,
    marginLeft: defaultScale(10)
  },
  subtitle: {
    ...Theme.textStyle.bodyCopyMed,
    marginTop: defaultScale(-10),
    paddingBottom: defaultScale(10),
    color: Theme.CHARCOAL,
  },
  headerTextStyle: {
    ...Theme.textStyle.header,
    borderBottomWidth: defaultScale(1),
    borderBottomColor: Theme.GREY_MEDIUM_LIGHT,
  },
});

const mapStateToProps = (state) => {
  return {
    isModalVisible: state.ui.workoutProgramSelectModalVisible,
    skillLevelSelectModalVisible: state.ui.skillLevelSelectModalVisible
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleWorkoutProgramSelectModalVisible: (visible) => dispatch(toggleWorkoutProgramSelectModalVisible(visible)),
    toggleSkillLevelSelectModal: (visible) => dispatch(toggleSkillLevelSelectModal(visible)),
    userGoalChanged: () => dispatch(userGoalChanged()),
  };
};

GoalsTab = connect(mapStateToProps, mapDispatchToProps)(GoalsTab);
GoalsTab = UserDataConsumer(GoalsTab);
GoalsTab = translate(['settings'], { wait: true })(GoalsTab);
GoalsTab = reduxForm({ form: 'GoalsAndSkillsForm' })(GoalsTab);
export default GoalsTab;
